module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_sand_1-efe12419f12126194b4d03a55eaf3953.png";